/* nord-header — JS estático extraído do <script> inline.
   Sem Liquid: idêntico em toda página, então vira asset cacheável. */
(function () {
    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

    /* --------------------------------------------------------------------
       <nord-header> — decides transparent vs solid.
       Transparent requires: the section allows it (server-side: setting +
       template=index) AND the first section of <main> opted in by rendering
       an element carrying [allow-transparent-header].
       ------------------------------------------------------------------ */
    if (!customElements.get('nord-header')) {
      customElements.define(
        'nord-header',
        class NordHeader extends HTMLElement {
          connectedCallback() {
            this.allow = this.dataset.allowTransparent === 'true';
            this.onSectionChange = this.resolve.bind(this);

            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', this.onSectionChange, { once: true });
            } else {
              this.resolve();
            }
            document.addEventListener('shopify:section:load', this.onSectionChange);
            document.addEventListener('shopify:section:unload', this.onSectionChange);
          }

          disconnectedCallback() {
            document.removeEventListener('shopify:section:load', this.onSectionChange);
            document.removeEventListener('shopify:section:unload', this.onSectionChange);
          }

          resolve() {
            var transparent = false;
            if (this.allow) {
              var main = document.getElementById('MainContent');
              var first = main ? main.querySelector('.shopify-section') : null;
              transparent = !!(first && first.querySelector('[allow-transparent-header]'));
            }
            this.dataset.mode = transparent ? 'transparent' : 'solid';
            document.body.classList.toggle('nord-header-transparent', transparent);
          }
        }
      );
    }

    /* --------------------------------------------------------------------
       <nord-header-nav> — hover + keyboard dropdowns, Escape/blur close.
       ------------------------------------------------------------------ */
    if (!customElements.get('nord-header-nav')) {
      customElements.define(
        'nord-header-nav',
        class NordHeaderNav extends HTMLElement {
          connectedCallback() {
            this.items = Array.prototype.slice.call(this.querySelectorAll('[data-has-panel]'));
            if (!this.items.length) return;

            this.closeTimer = null;
            this.setAttribute('data-enhanced', '');

            this.items.forEach(
              function (item) {
                item.addEventListener('mouseenter', this.open.bind(this, item));
                item.addEventListener('mouseleave', this.scheduleClose.bind(this, item));
                item.addEventListener('focusin', this.open.bind(this, item));
                item.addEventListener(
                  'focusout',
                  function (event) {
                    if (!item.contains(event.relatedTarget)) this.close(item);
                  }.bind(this)
                );
              }.bind(this)
            );

            this.onKeydown = function (event) {
              if (event.key !== 'Escape' && event.key !== 'Esc') return;
              var open = this.querySelector('[data-open]');
              if (!open) return;
              var trigger = open.querySelector('.nord-header__nav-link');
              this.close(open);
              if (trigger && open.contains(document.activeElement)) trigger.focus();
            }.bind(this);
            this.addEventListener('keydown', this.onKeydown);
          }

          disconnectedCallback() {
            if (this.closeTimer) clearTimeout(this.closeTimer);
          }

          open(item) {
            if (this.closeTimer) {
              clearTimeout(this.closeTimer);
              this.closeTimer = null;
            }
            this.items.forEach(
              function (other) {
                if (other !== item) this.close(other);
              }.bind(this)
            );
            item.setAttribute('data-open', '');
            var trigger = item.querySelector('.nord-header__nav-link');
            if (trigger) trigger.setAttribute('aria-expanded', 'true');
          }

          scheduleClose(item) {
            if (this.closeTimer) clearTimeout(this.closeTimer);
            this.closeTimer = setTimeout(
              function () {
                if (!item.contains(document.activeElement)) this.close(item);
              }.bind(this),
              120
            );
          }

          close(item) {
            item.removeAttribute('data-open');
            var trigger = item.querySelector('.nord-header__nav-link');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          }
        }
      );
    }

    /* --------------------------------------------------------------------
       <nord-menu-drawer> — slide-in menu with focus trap + scroll lock.
       ------------------------------------------------------------------ */
    if (!customElements.get('nord-menu-drawer')) {
      customElements.define(
        'nord-menu-drawer',
        class NordMenuDrawer extends HTMLElement {
          connectedCallback() {
            this.panel = this.querySelector('.nord-drawer__panel');
            this.opener = null;

            this.addEventListener('click', function (event) {
              if (event.target.closest('[data-nord-close]')) {
                event.preventDefault();
                this.close();
              }
            }.bind(this));

            this.onKeydown = this.handleKeydown.bind(this);

            var id = this.getAttribute('id');
            this.toggles = Array.prototype.slice.call(
              document.querySelectorAll('[data-nord-drawer-toggle][aria-controls="' + id + '"]')
            );
            this.toggles.forEach(
              function (toggle) {
                toggle.addEventListener(
                  'click',
                  function () {
                    this.opener = toggle;
                    this.open();
                  }.bind(this)
                );
              }.bind(this)
            );
          }

          disconnectedCallback() {
            document.removeEventListener('keydown', this.onKeydown);
            this.unlock();
          }

          open() {
            if (this.dataset.open === 'true') return;
            this.dataset.open = 'true';
            this.toggles.forEach(function (t) {
              t.setAttribute('aria-expanded', 'true');
            });
            document.addEventListener('keydown', this.onKeydown);
            this.lock();
            var first = this.panel ? this.panel.querySelector(FOCUSABLE) : null;
            if (first) first.focus();
          }

          close() {
            if (this.dataset.open !== 'true') return;
            this.dataset.open = 'false';
            this.toggles.forEach(function (t) {
              t.setAttribute('aria-expanded', 'false');
            });
            document.removeEventListener('keydown', this.onKeydown);
            this.unlock();
            if (this.opener) this.opener.focus();
          }

          lock() {
            document.body.style.overflow = 'hidden';
          }

          unlock() {
            document.body.style.overflow = '';
          }

          handleKeydown(event) {
            if (event.key === 'Escape' || event.key === 'Esc') {
              event.preventDefault();
              this.close();
              return;
            }
            if (event.key !== 'Tab' || !this.panel) return;

            var nodes = Array.prototype.filter.call(
              this.panel.querySelectorAll(FOCUSABLE),
              function (el) {
                return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
              }
            );
            if (!nodes.length) return;

            var first = nodes[0];
            var last = nodes[nodes.length - 1];

            if (!this.panel.contains(document.activeElement)) {
              event.preventDefault();
              first.focus();
              return;
            }
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
        }
      );
    }

    /* --------------------------------------------------------------------
       <nord-cart-count> — server-rendered count, refreshed on cart:refresh.
       ------------------------------------------------------------------ */
    if (!customElements.get('nord-cart-count')) {
      customElements.define(
        'nord-cart-count',
        class NordCartCount extends HTMLElement {
          connectedCallback() {
            this.bubble = this.querySelector('[data-nord-cart-count]');
            this.link = this.querySelector('[data-nord-cart-link]');
            this.refresh = this.refresh.bind(this);
            document.addEventListener('cart:refresh', this.refresh);
            document.addEventListener('cart:update', this.refresh);
          }

          disconnectedCallback() {
            document.removeEventListener('cart:refresh', this.refresh);
            document.removeEventListener('cart:update', this.refresh);
          }

          refresh(event) {
            var detail = event && event.detail;
            if (detail && typeof detail.item_count === 'number') {
              this.render(detail.item_count);
              return;
            }
            if (detail && detail.cart && typeof detail.cart.item_count === 'number') {
              this.render(detail.cart.item_count);
              return;
            }
            fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
              headers: { Accept: 'application/json' }
            })
              .then(function (response) {
                return response.ok ? response.json() : null;
              })
              .then(
                function (cart) {
                  if (cart) this.render(cart.item_count);
                }.bind(this)
              )
              .catch(function () {
                /* keep the server-rendered count */
              });
          }

          render(count) {
            if (!this.bubble) return;
            var value = this.bubble.querySelector('span');
            if (value) value.textContent = count;
            if (count > 0) {
              this.bubble.removeAttribute('hidden');
            } else {
              this.bubble.setAttribute('hidden', '');
            }
            if (this.link) this.link.setAttribute('aria-label', 'Cart, ' + count + ' items');
          }
        }
      );
    }

    /* Escape closes anything the header has open, including panels that were
       opened by hover (where focus never entered the nav). */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;

      var loc = document.querySelector('[data-nord-loc][open]');
      if (loc) {
        loc.removeAttribute('open');
        var summary = loc.querySelector('summary');
        if (summary) summary.focus();
      }

      var panels = document.querySelectorAll('.nord-header__nav-item[data-open]');
      for (var i = 0; i < panels.length; i++) {
        var trigger = panels[i].querySelector('.nord-header__nav-link');
        var hadFocus = panels[i].contains(document.activeElement);
        panels[i].removeAttribute('data-open');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          if (hadFocus) trigger.focus();
        }
      }
    });
    document.addEventListener('click', function (event) {
      var opened = document.querySelectorAll('[data-nord-loc][open]');
      for (var i = 0; i < opened.length; i++) {
        if (!opened[i].contains(event.target)) opened[i].removeAttribute('open');
      }
    });
  })();
